<template>
  <v-stepper v-model="bottleDepositStepper" alt-labels>
    <v-stepper-header>
      <v-stepper-step
          :complete="bottleDepositStepper > 1"
          step="1"
      >
        Markt auswählen
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step
          :complete="bottleDepositStepper > 2"
          step="2"
      >
        Pfand eingeben
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="3">
        Überprüfen
      </v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <div class="stepperSearchWrapper">
          <v-text-field class="stepperCbx"
                      append-icon=""
                      rounded
                      v-model="marketSearchCbx"
                      hide-details
          >
          </v-text-field>
        </div>
        <v-container>
          <v-row v-if="!loadingResults" :key="marketsFiltered">
            <v-col cols="12"
                   v-for="market in markets"
                   :key="market.marketNr"
                   v-bind:class="{marketActive : market.marketNr === activeMarket}"
            >
              <div class="marketWrapper">
                <div class="marketHeader">
                  <span>{{ market.city }}</span>
                </div>
                <v-row class="marketInfo text-align-left textSize__14">
                  <v-col cols="6">
                    <span>
                      {{ market.street}} {{ market.number }}
                      <br>
                      {{ market.city }}
                    </span>
                  </v-col>
                  <v-col cols="6">
                    <span>
                      {{ market.name }} ({{ market.customerNr }})
                      <br>
                      {{ market.marketNr }}
                    </span>
                  </v-col>
                </v-row>
                <v-btn class="marketSelectBtn"
                       @click="selectMarket(market.marketNr)"
                >
                  Markt auswählen
                </v-btn>
              </div>
              <v-divider/>
            </v-col>
          </v-row>
        </v-container>
        <v-btn
            class="stepperContinueBtn"
            @click="bottleDepositStepper = 2"
            :disabled="activeMarket===null"
        >
          Weiter
        </v-btn>
      </v-stepper-content>

      <v-stepper-content step="2">
        <div class="stepperSearchWrapper">
          <v-text-field class="stepperCbx"
                        append-icon=""
                        rounded
                        v-model="productSearchCbx"
                        hide-details
          >
          </v-text-field>
          <v-btn class="stepperCamBtn" @click="this.setBarcodeScannerState">
            <v-icon>
              mdi-camera
            </v-icon>
          </v-btn>

        </div>

        <v-container v-if="Object.keys(this.getDepositOverview).length > 0">
          <v-row class="reverseArticles">
            <v-col cols="12"
                   v-for="(deposit, key, index) in this.getDepositOverview"
                   :key="index"
            >
                <span>{{ depositTypes[key].name }}
                  <br>
                    {{ deposit }} x {{ depositTypes[key].deposit | parsePrice}} € ......
                    {{ deposit * depositTypes[key].deposit | parsePrice}} €
                </span>
              </v-col>
          </v-row>

        </v-container>

        <v-btn
            class="stepperContinueBtn"
            @click="bottleDepositStepper = 3"
        >
          Weiter
        </v-btn>

        <v-divider v-if="this.getDepositCollector.length > 0"/>
        <product-list :render-data="{cart: false, deposit: true, products: this.getDepositCollector, depositTypes: depositTypes}"/>
      </v-stepper-content>

      <v-stepper-content step="3">
        <v-card
            class="mb-12"
            color="grey lighten-1"
            height="200px"
        ></v-card>

        <v-btn
            class="stepperContinueBtn"
            color="primary"
            @click="bottleDepositStepper = 1"
        >
          Pfandrückgabe absenden
        </v-btn>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import {mapActions, mapMutations, mapGetters} from "vuex";
import axios from "axios";
import ProductList from "@/app/productListing/productList";

export default {
  name: "bottleDeposit",
  components: {ProductList},
  props: ['externalSetMarket'],
  data:() => {
    return {
      bottleDepositStepper: 1,
      marketSearchCbx: '',
      marketSearch: null,
      marketResults : [],
      loadingResults: false,
      marketsFiltered: false,
      activeMarket: null,

      productSearchCbx: '',


      depositTypes:{0: {name:'Träger', deposit: 1.5},
                    1: {name:'Mehrweg', deposit: 0.15},
                    2: {name:'Einweg', deposit: 0.25},
                    3: {name:'Glas', deposit: 0.08}},
    }
  },

  methods: {
    ...mapActions({
      setHeaderVisibility: 'setHeaderVisibility',
      openScanner: 'openScanner'
    }),

    ...mapMutations({
      setBarcodeScannerState: 'setBarcodeScannerState'
    }),

    sendDeposit() {
      console.log("Abgesendet")
    },

    searchMarkets(val) {
      if(val.length === 3 && this.marketResults.length === 0) {
        this.loadingResults = true
        axios.post('/vuerouter/db_query_stores.php', val)
            .then((result) => {
              this.marketResults = result.data
            })
            .finally(() =>{
              this.loadingResults = false
              if(this.marketResults.length > 0) {
                this.searchActive = true
              }
            })
      }

      else if(val.length < 3) {
        this.marketResults = []
        this.searchActive = false
        this.loadingResults = false
        this.activeMarket = null
      }
    },

    selectMarket(marketNr) {
      this.activeMarket = marketNr
    }
  },

  computed: {
    ...mapGetters({
      getDepositCollector: 'getDepositCollector',
      getDepositOverview: 'getDepositOverview'
    }),

    markets()  {
        if (this.marketResults.length > 0 && this.marketSearchCbx.length > 3) {
          const searchVal = this.marketSearchCbx.toLocaleLowerCase().trim()

          return this.marketResults.filter(val =>
              val.customerNr.toLowerCase().indexOf(searchVal) > -1 ||
              val.marketNr.toLowerCase().indexOf(searchVal) > -1 ||
              val.street.toLowerCase().indexOf(searchVal) > -1 ||
              val.number.toLowerCase().indexOf(searchVal) > -1 ||
              val.city.toLowerCase().indexOf(searchVal) > -1 ||
              val.name.toLowerCase().indexOf(searchVal) > -1
          )
        }
        else {
          return this.marketResults
        }
    }
  },

  mounted() {
    this.setHeaderVisibility(false)
    if(this.externalSetMarket) {
      this.selectMarket(this.externalSetMarket)
      this.bottleDepositStepper = 2
    }
  },

  watch: {
    marketSearchCbx() {
      this.searchMarkets(this.marketSearchCbx)
    },
  }
}
</script>

<style>

</style>
